import { TextBoxTypeEnum } from "../../../enums/TextBoxTypeEnum";
import {
  Button,
  CheckBox,
  DatePicker,
  Icon,
  ProvideTypeahead,
  Select,
  TextBox,
  Typeahead,
} from "../../../share/Elements";
import Card from "../../../share/Components/Card/Card";
import {
  DiagnosisItem,
  RecordDiagnosisType,
} from "../../../models/ViewModels/RecordViewModel";
import { LoadingFit } from "../../../share/Components";
import {
  DiagnosisType,
  ItemType,
} from "../../../models/ViewModels/RecordCatalogViewModel";
import { useSelector } from "react-redux";
import { ReducerType } from "../../../storeManager/ReducerType";
import useFetch from "../../../_services/fetch";
import { RaytebRequests } from "../../../_services";
import { LoginInterface } from "../../../Interfaces/LoginInterface";
import { useState } from "react";
import { toast } from "react-toastify";

type TypeaheadData = {
  show: boolean;
  data?: any;
};
const RecordDiagnosis = ({
  sevirity,
  diagnosisStatus,
  item,
  onItemChange,
}: {
  sevirity?: Array<ItemType<number>>;
  diagnosisStatus?: Array<ItemType<number>>;
  item?: RecordDiagnosisType;
  onItemChange: (updatedItem: RecordDiagnosisType) => void; // A function to handle item changes
}) => {
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  );
  const [showList, setshowList] = useState<TypeaheadData>({
    show: false,
  });
  const [showModal, setShowModal] = useState<TypeaheadData>({
    show: false,
  });
  const [diagnosis, setDiagnosis] = useState<DiagnosisItem>({
    severity: 1,
    status: 1,
    dateofOnset: new Date().toDateString(),
    timeofOnset: new Date().getFormattedTime(),
  });
  const getSymptom = useFetch<
    Array<ItemType<string>>,
    unknown,
    {
      filter: string;
    }
  >({
    request: RaytebRequests.Profile_GetDisease_GET({ token: user.token }),
    onSuccess(data) { },
  });
  const selectedItem = (item: ItemType<string>) => {
    const updatedItem: DiagnosisItem = {
      ...diagnosis,
      diseaseId: item.id,
      disease: item.title,
    };
    setDiagnosis(updatedItem);
    setshowList({ ...showList, show: false });
  };
  const handleAddItem = () => {
    if (!diagnosis.diseaseId) toast.error("یک مورد انتخاب کنید");
    else if (!diagnosis.dateofOnset) toast.error("تاریخ را انتخاب کنید");
    else if (!diagnosis.timeofOnset) toast.error("مقدار ساعت را انتخاب کنید");
    else {
      const updatedItems = item?.items ? [...item.items] : [];
      updatedItems.push(diagnosis);

      const updatedDiagnosisType: DiagnosisType = {
        ...item,
        items: updatedItems,
      };
      onItemChange(updatedDiagnosisType);
      setDiagnosis({
        description: "",
        timeofOnset: new Date().getFormattedTime(),
        disease: "",
        severity: 1,
        status: 1,
        dateofOnset: new Date().toDateString(),
      });
    }
  };
  const handleAbstractClick = (index: number) => {
    const updatedItems = [...(item?.items || [])];
    updatedItems[index] = {
      ...updatedItems[index],
      showAbstract: !updatedItems[index].showAbstract,
    };

    const checkupData: DiagnosisType = {
      ...item,
      items: updatedItems,
    };
    onItemChange && onItemChange(checkupData);
  };
  const handleDeleteClick = (index: number) => {
    const updatedItems = [...(item?.items || [])];
    updatedItems.splice(index, 1);

    const updatedObject = { ...item, items: updatedItems };

    onItemChange && onItemChange(updatedObject);
  };
  const handleTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDiagnosis({ ...diagnosis, timeofOnset: event.target.value });
  };
  return (
    <>
      <div className="p-6 ">
        <ProvideTypeahead
          className={` ${true ? "before:absolute before:z-50 " : ""}`}
          showList={showList.show}
          listChildren={
            <ListChildren
              onClick={(item) => {
                selectedItem(item);
              }}
              listData={getSymptom.result}
              isLoading={getSymptom.isLoading}
              onHide={() => setshowList({ show: false })}
            />
          }
        >
          <div className="px-1 flex justify-start  items-end md:!w-1/2 md:mx-auto ">
            <Typeahead
              innerText="نام بیماری"
              className="before:absolute before:bg-white/30 before:w-full before:h-full"
              onClick={(e) => {
                e.target.select();
              }}
              // onBlur={() => setshowList({ ...showList, show: false })}
              onFocus={() => setshowList({ ...showList, show: true })}
              onChange={(e) =>
                getSymptom.reFetch(null, {
                  filter: e.target.value,
                })
              }
              value={diagnosis?.disease}
            ></Typeahead>
          </div>
        </ProvideTypeahead>
        <div className="grid xs:grid-cols-2 grid-cols-8 gap-2 mt-2">
          <Select
            className="w-full h-9"
            onChange={(e) => {
              if (e.target.value && e.target.value !== "") {
                setDiagnosis({
                  ...diagnosis,
                  severity: e.target.value,
                });
              }
            }}
            value={diagnosis?.severity}
          >
            {sevirity?.map((n, i) => (
              <option key={i} value={n.id}>
                {n.title}
              </option>
            ))}
          </Select>
          <Select
            className="w-full h-9"
            onChange={(e) => {
              if (e.target.value && e.target.value !== "") {
                setDiagnosis({
                  ...diagnosis,
                  status: e.target.value,
                });
              }
            }}
            value={diagnosis?.status}
          >
            {diagnosisStatus?.map((n, i) => (
              <option key={i} value={n.id}>
                {n.title}
              </option>
            ))}
          </Select>
          <DatePicker
            innerText="تاریخ"
            isRequired={false}
            className=""
            name="Date"
            id="Date"
            raytebValue={diagnosis?.dateofOnset}
            value={
              diagnosis?.dateofOnset
                ? new Date(diagnosis.dateofOnset).toShamsi()
                : ""
            }
            onChange={(e) => {
              // const fromDateInput = document.getElementById("Date"); // Assuming you have an element with id "toDate"
              // const raytebValue = fromDateInput?.getAttribute("rayteb-value");
              const updatedItem: DiagnosisItem = {
                ...diagnosis,
                dateofOnset: e.target.valueMiladi,
              };
              setDiagnosis(updatedItem);
            }}
          />
          <TextBox
            className="w-full h-9 "
            Regular="^(([01]?[0-9]|2[0-3]):[0-5][0-9]){1,5}$"
            RxgMessage="از 00:00 تا 23:59"
            innerText="ساعت"
            isRequired={false}
            debounceTime={0}
            Type={TextBoxTypeEnum.Time}
            value={diagnosis?.timeofOnset!}
            onChange={handleTimeChange}
          />
        </div>

        <div className="mt-4 grid grid-cols-9 gap-1">
          <div className="col-span-8">
            <TextBox
              debounceTime={0}
              innerText="توضیحات"
              className="w-full "
              Type={TextBoxTypeEnum.Text}
              value={diagnosis?.description}
              onChange={(e) =>
                setDiagnosis({ ...diagnosis, description: e.target.value })
              }
            />
          </div>
          <Icon
            icon="rayteb-microphone"
            className="text-xl w-full text-disable h-full rounded-full  "
          />
        </div>
        <div className="flex justify-between items-center mt-3 px-1">
          {/* <CheckBox
            lable="نمایش خلاصه پرونده"
            className="text-xs"
            onChange={() => {}}
          /> */}
          <Icon
            icon="rayteb-add-circular"
            className="text-xl mr-auto text-primaryLight"
            onClick={handleAddItem}
          />
        </div>

        <div className="mt-5 grid grid-cols-1 gap-1 ">
          {item?.items?.map((n, i) => (
            <Card
              key={i}
              text={n.disease}
              footer={
                <CardFooter
                  diagnosisItem={n}
                  onAbstractClick={() => handleAbstractClick(i)}
                  onDeleteClick={() => handleDeleteClick(i)}
                />
              }
            >
              <div className="ml-1 flex gap-2">
                <span className="text-xs">{sevirity?.find(x => x.id == n.severity)?.title}</span>
                <span className="text-xs">{diagnosisStatus?.find(x => x.id == n.status)?.title}</span>
                <span className="text-xs text-primaryLight">
                  {new Date(n.dateofOnset!).toShamsi()}
                </span>
                <span className="text-xs">{n.timeofOnset}</span>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </>
  );
};
const CardFooter = ({
  diagnosisItem,
  onAbstractClick,
  onDeleteClick,
}: {
  diagnosisItem?: DiagnosisItem;
  onAbstractClick: () => void;
  onDeleteClick: () => void;
}) => (
  <>
    <div className="w-full flex justify-between items-center py-3">
      <Button className="bg-white border border-disable py-1 text-xs text-primary">
        {diagnosisItem?.description!}
      </Button>

      <div className="flex justify-center itmes-center gap-2">
        <Icon
          icon="rayteb-delete"
          className="text-xl text-primary"
          onClick={onDeleteClick}
        />
        <Icon
          icon="rayteb-medical-ophthalmology"
          className={`text-xl  ${diagnosisItem?.showAbstract ? "text-primary" : "text-disable"
            }`}
          onClick={onAbstractClick}
        />
      </div>
    </div>
  </>
);
type ListChildrenType = {
  listData?: Array<ItemType<string>>;
  className?: string | undefined;
  isLoading: boolean;
  onHide?: () => void;
  onClick?: (param: ItemType<string>) => void;
};
const ListChildren: React.FC<ListChildrenType> = ({
  className,
  listData,
  isLoading,
  onClick,
  onHide,
}) => {
  return (
    <>
      <div>
        <LoadingFit isLoading={isLoading} />
        <div className="border-b border-disable bg-white py-2 px-1 flex items-center">
          <Icon
            icon="rayteb-android-close"
            className="text-xl"
            onClick={() => onHide?.()}
          />

          <p className="text-xs mr-2 font-bold text-warn ">علائم بیماری ...</p>
        </div>

        <div className="h-64 overflow-y-auto">
          <ul
            className={`flex justify-center flex-col  
           items-center p-2 shadow-sm ${className ?? ""}`}
          >
            {listData?.map((n, i) => (
              <li
                key={i}
                className="flex justify-start items-center h-8  py-1 w-full hover:bg-primaryDefault hover:cursor-pointer "
                onClick={() => onClick?.(n)}
              >
                <p className="text-xs font-bold text-end text-primaryLight">
                  {n.title}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};
export default RecordDiagnosis;
